import { Injectable } from "@angular/core";
import { DISABLE_ANALYTICS_COOKIES_COOKIE_KEY } from "app/common";
import { CookieService } from "ngx-cookie-service";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class FacebookPixelConsentService {
  private analyticsConsent$ = new BehaviorSubject<boolean>(
    this.cookieService.get(DISABLE_ANALYTICS_COOKIES_COOKIE_KEY) === "false"
  );
  analyticsConsentChanges$ = this.analyticsConsent$.asObservable();

  constructor(private cookieService: CookieService) {}

  setConsent(allow: boolean) {
    this.cookieService.set(DISABLE_ANALYTICS_COOKIES_COOKIE_KEY, (!allow).toString(), { path: "/", sameSite: "Lax" });
    this.analyticsConsent$.next(allow);
  }
}
